

// Utility to format date as YYYY-MM-DD
export const formatDate = date =>
    new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];

// Normalize backend training status values so UI logic handles variant formats consistently.
export const normalizeTrainingStatus = status =>
    String(status ?? '')
        .trim()
        .toUpperCase()
        .replace(/\s+/g, '_');

export const isTrainingSucceededStatus = status => {
    const normalizedStatus = normalizeTrainingStatus(status);
    return normalizedStatus === 'SUCCEEDED' || normalizedStatus === 'SUCCESS' || normalizedStatus === 'COMPLETED';
};

export const isTrainingInProgressStatus = status => {
    const normalizedStatus = normalizeTrainingStatus(status);
    return (
        normalizedStatus === 'RUNNING' ||
        normalizedStatus === 'INPROGRESS' ||
        normalizedStatus === 'IN_PROGRESS'
    );
};

// Shared color palette for charts
export const chartColorPalette = [
            '#5470C6', // blue
            '#91CC75', // green
            '#FAC858', // yellow
            '#73C0DE', // cyan
            '#9A60B4', // purple
            '#EA7CCC' // pink
];
